var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/arrow-left"
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrow-left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.35 15.5666L11.025 12.8916L12.6667 11.2583C13.3583 10.5666 13.3583 9.44163 12.6667 8.74997L8.35 4.4333C7.78334 3.86663 6.81667 4.27497 6.81667 5.06663L6.81667 9.74163L6.81667 14.9333C6.81667 15.7333 7.78333 16.1333 8.35 15.5666Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewArrowLeft);
export default __webpack_public_path__ + "static/media/new-arrow-left.688c89e8f44705a2c2a1d083c6c76650.svg";
export { ForwardRef as ReactComponent };